import axios from "axios";
import appState from "../state/AppStateContainer.js";

interface Template {
  _id: string;
  name: string;
  categories: string[];
  orgId: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export class ServiceTemplateController {
  async getTemplates(): Promise<Template[]> {
    try {
      const orgSlug = appState.getCurrentOrgSlug();
      const response = await axios.get(`/api/organizations/${orgSlug}/template`);
      return response.data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    }
  }

  async saveTemplate(name: string, categories: string[]): Promise<Template> {
    try {
      const orgSlug = appState.getCurrentOrgSlug();
      const response = await axios.post(`/api/organizations/${orgSlug}/template/create`, {
        name,
        categories
      });
      return response.data;
    } catch (error) {
      console.error('Error saving template:', error);
      throw error;
    }
  }

  async deleteTemplate(templateId: string): Promise<void> {
    try {
      const orgSlug = appState.getCurrentOrgSlug();
      await axios.delete(`/api/organizations/${orgSlug}/template/${templateId}`);
    } catch (error) {
      console.error('Error deleting template:', error);
      throw error;
    }
  }
}

export const ServiceTemplate = new ServiceTemplateController(); 